import { Injectable } from "@angular/core";
import { TokenService } from "./token.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { map, Observable, of } from "rxjs";
import { User, UserFormDto } from "../../shared/models/user";
import { Role, UserRole } from "../../shared/data-types/roles.enum";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private baseUrl = environment.apiUrl;

  constructor(private tokenService: TokenService, private http: HttpClient) {}

  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${this.baseUrl}/user/all-users`);
  }

  updateUser(user: UserFormDto): Observable<UserFormDto> {
    return this.http.post<UserFormDto>(`${this.baseUrl}/user/user`, user);
  }

  getUserProfile(email: string): Observable<UserFormDto> {// TDO: change server UserDTO
    return this.http.get<UserFormDto>(`${this.baseUrl}/user/profile`, {
      params: { email },
    })
  }

  updateUserProfile(userRole: UserRole): Observable<User> {
    return this.http.post<User>(`${this.baseUrl}/user/profile`, userRole);
  }

  /** Obtener el nombre del usuario desde el token */
  getUsername(): string | null {
    const token = this.tokenService.getToken();
    if (!token) return null;

    const payload = this.decodeToken(token);
    return payload?.name || payload?.sub || null; 
  }

  getUser(): Observable<User | null> {
    const email = this.getUsername();
    if (!email) return of(null);

    return this.http.get<any>(`${this.baseUrl}/user/profile?email=${encodeURIComponent(email)}`).pipe(
      map((response) => {
        if (response) {
          const { userRole, ...userData } = response;
          return { ...userData, role: response.userRole.name as UserRole } as User;
        }
        return null;
      })
    );
  }

  getMarketProfiles(): Observable<{ id: number; name: string }[]> {
    return this.http.get<{ id: number; name: string }[]>(`${this.baseUrl}/market/profiles`);
  }

  private decodeToken(token: string): any {
    try {
      const payload = atob(token.split(".")[1]);
      return JSON.parse(payload);
    } catch (error) {
      return null;
    }
  }
}
